import STRINGS from "../utils/strings";

const NoAvailableFollowUps = () => {
  return (
    <div className="followup-item rounded-md border-t-[2px] border-solid border-slate-500 bg-slate-100 py-2 text-center">
      <span className="rounded-md border-solid border-white bg-white px-3 py-1 text-sm text-slate-800">
        {STRINGS.NO_FOLLOW_UPS_AVAILABLE}
      </span>
    </div>
  );
};
export default NoAvailableFollowUps;
